module.exports = __webpack_public_path__ + "static/media/powered_by_stripe.552f9814.svg";